export default __webpack_public_path__ + "static/media/MIE_Dark_Black.76cd134c.png";